import { FunctionComponent, ReactElement } from "react";
import { useQuery } from "urql";
import { GET_CATEGORY_INFO } from "../../queries/getCategoryInfo.gql";
import { Query } from "../../queries/graphql";

interface IComponentProps {
  id: number;
  title?: string;
  classes?: {
    root?: string;
  };
  children?: ReactElement;
}
export const LazyLinkToCategory: FunctionComponent<IComponentProps> = ({
  id,
  title,
  classes,
  children,
}) => {
  const [{ data, fetching }] = useQuery<Query>({
    query: GET_CATEGORY_INFO,
    variables: { id },
  });
  if (!data?.category.url_path || fetching) {
    return <div>Loading...</div>;
  }

  return (
    <a
      href={"/" + data?.category.url_path}
      className={classes?.root}
      style={{ textDecoration: "none" }}
    >
      {children ? <>{children}</> : title ?? data?.category.name}
    </a>
  );
};
